const RANKING_DATA = [
  { rank: 1, title: '某顶流男星深夜密会神秘女子', heat: '980万', tag: '爆', tagColor: 'bg-primary-500' },
  { rank: 2, title: '热播剧女主片场耍大牌内幕曝光', heat: '856万', tag: '热', tagColor: 'bg-accent-500' },
  { rank: 3, title: '知名歌手新恋情疑似浮出水面', heat: '742万', tag: '新', tagColor: 'bg-secondary-500' },
  { rank: 4, title: '综艺节目录制现场突发意外状况', heat: '689万', tag: '热', tagColor: 'bg-accent-500' },
  { rank: 5, title: '娱乐圈最新合约纠纷全记录', heat: '521万', tag: '', tagColor: '' },
  { rank: 6, title: '某品牌代言人突然宣布解约', heat: '468万', tag: '', tagColor: '' },
  { rank: 7, title: '年度十大娱乐事件最新盘点', heat: '395万', tag: '', tagColor: '' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            <i className="ri-fire-line text-primary-500 mr-2"></i>吃瓜热度榜
          </h2>
          <p className="mt-2 text-sm text-foreground-500">实时追踪全网最热吃瓜内容，热度数据实时更新</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {RANKING_DATA.slice(0, 3).map((item) => (
            <div
              key={item.rank}
              className="relative bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className="flex items-start gap-4">
                <div className={`w-10 h-10 rounded-xl flex items-center justify-center font-heading text-lg font-bold shrink-0 ${
                  item.rank === 1 ? 'bg-primary-500 text-white' :
                  item.rank === 2 ? 'bg-accent-500 text-white' :
                  'bg-secondary-500 text-white'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                  <div className="mt-2 flex items-center gap-2">
                    {item.tag && (
                      <span className={`inline-block px-2 py-0.5 rounded text-[10px] font-bold text-white ${item.tagColor}`}>
                        {item.tag}
                      </span>
                    )}
                    <span className="text-xs text-foreground-400">
                      <i className="ri-eye-line mr-1"></i>{item.heat}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {RANKING_DATA.slice(3).map((item) => (
            <div
              key={item.rank}
              className="bg-background-100/70 border border-background-200/60 rounded-xl p-4 hover:border-primary-200 transition-colors cursor-pointer group flex items-center gap-3"
            >
              <span className="w-8 h-8 rounded-lg flex items-center justify-center font-heading text-base font-bold text-foreground-500 bg-background-200 shrink-0">
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {item.title}
                </h3>
              </div>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}